import {green} from "@material-ui/core/colors";

import BG from "./../../files/img/auth-bg.jpg";

const drawerWidth = 220;
export const  Styles = theme =>( {
    paperLoginPage: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding:theme.spacing(3),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    requiredSign:{
        color:"#db2d2d",

    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    root: {
        display: 'flex',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        backgroundColor: '#fcfcfc',
        overflowY:'hidden'
    },
    mainContent: {
        flex: 1,
        display: 'flex',
    },
    WelcomRroot:{
        display: 'flex',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    toolbar: {
        paddingLeft: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        color: "#fff",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    colorWhite:{
        color:"rgba(255, 255, 255, 0.9)",
        width: "0.9em !important",
        height: "0.9em !important",
    },
    titleIcon: {
        float:"right"
    },
    appBar: {
        backgroundColor:"#2b2b2b",
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        backgroundColor:"#2b2b2b",

    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        backgroundColor: "#2b2b2b",
        color: "#fff",
        position: 'fixed',
        whiteSpace: 'nowrap',
        overflowX:"hidden",
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(0),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(8),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        overflow: 'auto',
        [theme.breakpoints.up('lg')]: {
            marginLeft:'16rem'
        },
    },
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        marginTop:78,


    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        borderRadius:10,
        overflow: 'auto',
        flexDirection: 'column',
        boxShadow:"0px 0px 10px rgba(82, 82, 82, 0.21)",
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        marginBottom:  theme.spacing(1)
    },
    SidebarPaper:{
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        marginBottom:  theme.spacing(1)
    },
    fixedHeight: {
        height: 240,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    DrawerRoot: {
        width: '100%',
        maxWidth: drawerWidth,

    },
    activeItem: {
        color: "#ffffff",
        backgroundColor: "#4c4c4c",
        borderLeft:"5px solid " + theme.palette.primary.light ,
        display:"block",
        textDecoration: "none"
    },
    activeItemDropDown:{
        color: "#ffffff",
        backgroundColor: "#4c4c4c",
        borderLeft:"5px solid " + theme.palette.primary.light ,

    },
    listItemText: {
        textDecoration: "none"
    },
    Tabroot: {
        flexGrow: 1,
        maxWidth: 370,
        overflow:"hidden",
        [theme.breakpoints.down('md')]: {
            maxWidth: 330,
        },
    },
    tabHeader: {
        backgroundColor:theme.palette.primary.main,
        color: "rgba(255,255,255,.5)",
        '& .MuiTab-textColorPrimary': {
            color: "rgba(255,255,255,.5)"
        },
        '& .Mui-selected': {
            color: theme.palette.secondary.main
        },
        '& .MuiTabs-indicator': {
            height:4
        },

    },
    ProfileDrawer:{
        backgroundColor: "#424242",
        color: "#fff",
        width:370,
        zIndex:3000000,
        [theme.breakpoints.down('md')]: {
            width: 330,
        },
    },
    DataTable: {
        backgroundColor:'#ffffff',
        display:"none"
    },
    addButton: {
        textDecoration: "none",
    },

    appBarDialog: {
        position: 'relative',
        zIndex: 99999999,
        backgroundColor:theme.palette.primary.light
    },
    titleDialog: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    FileManagerInput: {
        display:"none"
    },
    ButtonProgress: {
        fontSize:20
    },
    FMThumbnail: {
        width:50,
        borderRadius: '10%',
        cursor:'pointer'

    },
    sticky: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        position:"sticky",
        top: 100,
    },
    galleryRoot: {
        maxWidth: 150,
        margin:10,
        display:"inline"
    },
    litleUrlShower:{
        fontSize: 11,
        color:theme.palette.primary.light,
        fontWeight:700,
        cursor: "pointer",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
    },
    Stepperroot: {
        width: '100%',
        backgroundColor:"#fff",
        padding: theme.spacing(2),
    },
    Stepperbutton: {
        marginRight: theme.spacing(1),
    },
    backStepperbutton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    StepperInstructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    messagesScreenRoot: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    appsContentContainer:{
        display: 'flex',
        flexDirection: 'column',
        overflow:"auto",
        height: `calc(100% - 115px)`,
        [theme.breakpoints.up('sm')]: {
            height: `calc(100% - 60px)`,
        },
        [theme.breakpoints.up('xl')]: {
            height: `calc(100% - 77px)`,
        },
    },
    emojiOpener:{
        position: "absolute",
        bottom: 5,
        right: 5
    },
    messageItemRoot: {
        marginBottom: 22,
        '&:last-child': {
            marginBottom: 0,
        },
        '&.right $messageChatRoot': {
            '& .message-time': {
                marginLeft: 0,
                marginRight: 55,
                textAlign: 'right',
            },
        },
        '&.right $messageChat': {
            flexDirection: 'row-reverse',
            backgroundColor:"#232f3e",
            color: theme.palette.background.default,
            '& .MuiAvatar-root': {
                marginRight: -65,
                marginLeft: 0,
            },
            '& .message-info': {
                marginLeft: 0,
                display: 'flex',
                alignItems: 'center',
            },
        },
    },
    messageChatRoot: {
        position: 'relative',
    },
    messageTime: {
        fontSize: 12,
        marginLeft: 55,
        marginBottom: -15,
        color: theme.palette.grey[500],
        display: 'block',
    },
    messageChat: {
        display: 'flex',
        borderRadius: 4,
        padding: '5px 15px',
        position: 'relative',
        marginLeft: 35,
        marginRight: 35,
        marginTop: 20,
        marginBottom: 10,
        maxWidth:650,
        minWidth:100,
        backgroundColor: "#f6f6f6",
        '& .MuiAvatar-root': {
            marginLeft: -65,
            marginTop: -5,
        },
        '& .message-info': {
            fontSize: 14,
            minWidth:300,
            marginTop:10,
            paddingRight:20,
            paddingLeft:20,
            marginBottom:10,
            [theme.breakpoints.up('lg')]: {
                fontSize: 16,
            },
        },
    },
    textPointer: {
        cursor: 'pointer',
    },
    GridAsaPaper:{
        backgroundColor: "#fff",
        borderRadius: 10,
        marginTop:15,
        boxShadow:"0px 0px 10px rgba(82, 82, 82, 0.21)",
        padding: 10
    },
    GridAsaPaperTransParent:{
        padding: 10
    },
    MenuItemDef: {
        color: 'rgba(0, 0, 0, 0.54)'
    },
    BreadLink: {
        display: 'flex',
    },
    BreadIcon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    breadCrumb: {
        marginTop: 12,
        [theme.breakpoints.down('sm')]: {
            fontSize:'12px',
        },
    },
    LoadingButtonWrapper: {
        position: 'relative',
        margin: theme.spacing(2,0),
        textAlign:'center'
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: "#ff9f00",
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    LoadingButtonRoot: {
        display: 'flex',
        alignItems: 'center',
    },
    ListRootWithoutHeight: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        overflowY:"auto",
        height: '100%',
        maxHeight: 300,
        marginBottom: 10,
    },
    ListRootWithHeight: {
        minHeight:300
    },
    link:{
        color: theme.palette.primary.main,
        '&:hover': {
            textDecoration:"none",
        },
    },
    linkSecondary:{
        '&:hover': {
            textDecoration:"none",
        },
    },
    loginPageLogo:{
        maxHeight:70,
        margin:15
    },
    loginPageContainer:{
        height:"100vh",
        backgroundColor:"#f7f7f7"
    },
    LoginFormGrid:{
        borderRadius:10,
        backgroundColor:'#ffffff',
        padding:"30px !important"
    },
    image: {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    mainLogo:{
        maxHeight:50,
        paddingRight:10
    },
    NotificationsHolder:{
        padding:10,
        height:'88%',
        overflow:"auto"
    },
    NotificationAlert: {
        marginTop:10
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    large: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    ListItemWidth:{
        minWidth: "30px !important"
    },
    activeProfileItem:{
        color: "#2b2b2b",
        fontSize: "10px !important",
        backgroundColor:"#f9f9f9",
        borderLeft:"5px solid " + theme.palette.primary.light ,
        '&:hover': {
            color: theme.palette.text.primary,
        }
    },
    CartBox:{
        paddingTop:"18px !important"
    },
    CartBoxWithoutPadding: {
        backgroundColor: "#f9f9f9",
        borderRadius:4,
        paddingTop:"0 !important",
        marginTop:'10px !important',
    },
    Step:{
        cursor:"pointer",
    },
    filterContainer:{
        backgroundColor:"#f6f6f6",
        padding:15,
        borderRadius:4,
        position:'relative',
        marginBottom:20,
    },
    primaryLink:{
        color:theme.palette.primary.main
    },
    ProviderManagerRoot: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    dashboardTitle : {
        borderBottom: "1px solid #bbb",
        paddingTop:15,
        paddingBottom:5,
        fontWeight: 700 ,
        display: "block",
        fontSize:20
    },
    ListRoot: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        overflowY:"auto",
        height: '100%',
        maxHeight: 450,
        marginBottom: 10
    },
    PassVisibilityIcon: {
        position: "absolute !important",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)"
    },
    GridAsaPaperBaby:{
        borderRadius: 5,
        paddingBottom:20,
        paddingTop:10,
    },
    GridAsaPaperLive:{
        backgroundColor: "#fff",
        borderRadius: 7,
        paddingBottom:15,
        boxShadow:"0px 0px 3px rgba(129, 128, 128, 0.15)",

    },
    AnalyticsResult: {
        fontSize: 20,
        fontWeight: 700,
        color:" #3e3c3c",
    },
    SuccessAnalytic:{
        float:"right",
        backgroundColor:"rgba(255, 255, 255, 0.47)",
        borderRadius: 5,
        color: "#5eb94b",

    },
    FlatAnalytic:{
        color:"#2b2b2b",
        backgroundColor:"rgba(233, 233, 233, 0.47)",
        padding:"2px 8px",
        borderRadius: 5,
        float:"right"
    },
    ErrorAnalytic:{
        backgroundColor:"rgba(255, 255, 255, 0.47)",
        color: "#ab2a2a",
        padding:"2px 8px",
        borderRadius: 5,
        float:"right"
    },
    ErrorAnalyticLive:{
        backgroundColor:"#ab2a2a",
        color: "#ab2a2a",
        padding:"2px 8px",
        borderRadius: "50%",
    },
    styledImg: {
        height: 430,
        display: 'inline-block',
        [theme.breakpoints.up('lg')]: {
            paddingRight: 40,
        },
        [theme.breakpoints.up('xl')]: {
            height: 'auto',
        },
    },
    AuthLogoMobile:{
        zIndex:10,
        maxWidth:70,
        marginBottom:10
    },
    AuthLogo:{
        maxWidth:150
    },
    textField: {
        width: '100%',
    },
    containerFull: {
        backgroundColor:"#f9f9f9"

    },
    loginContainerText: {
        alignContent: "center"
    },
    loginContainerForm:{
        textAlign: 'center',
        overflow: 'hidden',
        position:'relative',
        minHeight:600,
        zIndex: 0,
        paddingTop:20,
        paddingBottom:20
    },
    auth_bg_section:{
        backgroundColor: 'rgb(30,41,59)',
    },
    headLine: {
        fontWeight:"700 !important",
        fontSize:'20px !important',
        marginBottom: '20px !important',
        color:"#fff",
        textAlign:"center"
    },
    subLine: {
        fontSize:'17px !important',
        margin: '0 25px !important',
        textAlign:"center",
        color:"#e7e7e7",
    },
    AuthCard: {
        width: '100%',
        padding: "0 32px",
        overflow: 'hidden',
    },
    AuthGrid: {
        textAlign: 'center',
    },
    AuthButton: {
        width: '100%',
        height: 44,
    },
    socialLogin: {
        maxWidth: 27,
    },
    pointer: {
        cursor: 'pointer',
    },
    notiBtn: {
        justifyContent: 'flex-start',
        width: '100%',
        height: 56,
        fontSize: 18,
        borderRadius: 0,
        paddingLeft: '1rem',
        paddingRight: '1rem',
        color: "#fff",
        [theme.breakpoints.up('sm')]: {
            height: 70,
        },
        [theme.breakpoints.up('md')]: {
            justifyContent: 'center',
            width: 'auto',
            color: "#fff",
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
        },
        [theme.breakpoints.up('xl')]: {
            paddingLeft: '2.5rem',
            paddingRight: '2.5rem',
        },
    },
    notiIcon: {
        fontSize: 28,
        color: "#fff",
        [theme.breakpoints.up('xl')]: {
            fontSize: 22,
        },
    },
    walletBtn:{
        borderRadius:0,
        justifyContent: 'flex-start',
        width: '100%',
        height: 56,
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-end',

        },
        [theme.breakpoints.up('sm')]: {
            height: 70,
        },
    },
    NotifcationText:{
        color: "#2f2f2f",
        fontWeight:700,
        fontSize:12,
        marginBottom:0,
        textAlign:'right'
    },
    authFormHolder:{
        background: "#fff",
        padding: "20px 40px 40px !important",
        boxShadow: "0 0 10px #ddd",
        borderRadius: 10,
        position:"relative !important",
        [theme.breakpoints.down('sm')]: {
            padding: "10px 20px 20px !important",

        }
    },
    auth_container: {
        textAlign: 'center',
        minHeight: '100vh',
        backgroundColor:"#e3eeff",
        backgroundImage:`url(${BG})`,
        backgroundSize:"cover",
        backgroundPosition:"bottom center",
        backgroundRepeat:'no-repeat',
        marginTop:"0 !important",
        marginBottom:"0 !important",
        display:"flex",
        justifyContent:"flex-end",
        alignItems:'center',
        alignContent:'center',
        [theme.breakpoints.down('sm')]: {
            justifyContent:"center",
            backgroundPosition:"bottom left",
        }
    },
    auth_inner:{
        width:"34%",
        marginRight:'13%',

        [theme.breakpoints.down('sm')]: {
            width: "95%",
            marginTop:50,
            marginBottom:20,
            marginRight:0,
        },
        display:"flex",
        flexDirection:"column",
        alignItems:"center"
    },
    auth_container_data_items:{
        display:"flex",
        alignItems:"center",
        justifyContent:"center"
    },
    single_item:{
        marginLeft:4,
        marginRight:4,
        marginTop:10,
        color: "#d4d4d4",
        fontWeight: 400,
        "& p":{
            display:"flex",
            flexDirection:"column",
            padding:5,
            borderRadius:8,
            color:"#fff",
            backgroundColor:"rgba(44,44,44,0.5)",
            fontSize:10,
            minWidth:75
        },
        "& strong":{
            margin:"0 5px",
            fontSize:17,
            color:theme.palette.secondary.main
        }
    },
    auth_title:{
        display:"inline-flex",
        alignItems:'center',
        justifyContent:"center",
        borderBottom:"3px solid",
        borderBottomColor:theme.palette.primary.main,
        marginBottom:20,
        paddingBottom:10
    },
    auth_logo:{
      width:75,
      marginBottom:0,
        position:"absolute",
        left:10,
        top:10,
    },
    auth_about_desc:{
        position:"absolute",
        right:10,
        top:10,
        color:"#fff"
    },
    auth_container_items:{
        width:475,
        display:"flex",
        minHeight:450,
        alignItems:"center",
        justifyContent:"center",
        borderRadius:20,
        background:'#fff',
        [theme.breakpoints.down('sm')]: {
            width:"90%",
            minHeight:400,
        }

    },
    loginContainerFormBrd:{
        borderLeft:"1px solid #ddd !important",
        [theme.breakpoints.down('md')]: {
            borderLeft:"none !important",
        }
    },
    primaryColor:{
        color:theme.palette.primary.main
    },
    singleImageHolder:{
        position:"relative",
        borderRadius:5,
        '& button': {
            position: "absolute",
            bottom: 0,
            width: '100%',
            backgroundColor: "#fff !important",
            left:0,
            right:0,
        }
    },
    addImageBtn:{
        width: "100%",
        aspectRatio:"4 / 3",
        padding:"20px !important",
        '& .MuiButton-label': {
            display:"flex",
            flexDirection:"column",
            justifyContent:"center",
            alignItems:"center",
            '& .MuiButton-startIcon': {
                margin:"0 !important",
                '& .MuiSvgIcon-root': {
                    fontSize:40,
                    margin:"0 0 10px !important",
                },
            },
        },
    },
});